

$(document).ready(function() {

    

    $(document).on('click','[href="#trigger-form-tartufo-fresco"]', function(e) {
        e.preventDefault();
        $('.bcontact-trigger-button').trigger('click');
    });

    // accordion
     var delayIn = 500,
         delayOut = 300,
         $accordionParent = $('.js-blu-accordion-parent'),
         accortionTitleSelector = 'h4';

      $accordionParent.find(accortionTitleSelector).addClass('accordion-title');
      $accordionParent.find(accortionTitleSelector).nextUntil(accortionTitleSelector+',hr').addClass('accordion-cont');
      $('.accordion-title').next('.accordion-cont').addClass('first-after-title');
      $('.accordion-title').prev('.accordion-cont').addClass('last-before-title');
      $('.accordion-title:eq(0)').addClass('first-of-type');
      $('.accordion-cont:eq(-0)').addClass('last-of-type');
      $('.accordion-title').append('<i class="ci-arrow"></i>');/*<i class="fa fa-angle-down ci wf ts"></i>*/
      $('.accordion-cont').hide();
      $('.accordion-title').click(function () {
            var $accordionTitle = $(this);
            var $accordionContent = $(this).nextUntil(accortionTitleSelector+',hr');
            if ($accordionContent.is(':visible')) {
                $accordionContent.slideUp(delayOut, function () {
                    $accordionTitle.addClass('is-closed').removeClass('is-open');
                });
            } else {
                $accordionContent.slideDown(delayIn, function () {
                    $accordionTitle.addClass('is-open').removeClass('is-closed');
                });
            }
     });



    // navtoggle
    var openClass = 'is-open';
    var hoverClass = 'is-hover';
    var clickableClass = 'is-clickable';
    
    var bodyOpenClass = 'has-header-navt-open';
    
    $(document).on('click','.navt-button',function(e) {
        if (!$(this).parent('.navt').hasClass(clickableClass)) {
            e.preventDefault();
        }
        var $navButton = $(this);
        var $navContent = $navButton.next('.navt-content');
        var $nav = $navContent.parents('.navt');
        
        
        if( $nav.hasClass(openClass) ) {
            $nav.not('.navt-no-dismiss').removeClass(openClass);
            $('body').removeClass(bodyOpenClass);
        } else {
            $('body').addClass(bodyOpenClass);
            $('.navt').not($nav).not('.navt-no-dismiss').removeClass(openClass);
            $nav.addClass(openClass);
            if ($nav.find('.trigger-input-focus').length) {
                $('.trigger-input-focus').focus();
            }
        }
        
        if ($('#nav .navt.is-open').length) {
            //console.log('true');
            $('body').addClass(bodyOpenClass);
        } else {
            $('body').removeClass(bodyOpenClass);
            //console.log('false');
        }
        
        
    });
    
    $(document).on('mouseup', document ,function(e) {
        var $nav = $('.navt').not('.navt-no-dismiss');
        // if the target of the click isn't the $navContent...
        // && ... nor a descendant of the $navContent
        if ( !$nav.is(e.target) && $nav.has(e.target).length === 0) {
            $nav.removeClass(openClass);
            $('body').removeClass(bodyOpenClass);
        }
    });
    
    // consente di chiudere il menu/tooltip nel caso di hover
    $(document).on('click','.navt.'+hoverClass+' .navt-content',function() {
        var $nav = $(this).parents('.navt');
        $nav.removeClass(hoverClass);
        setTimeout(function() {
            $nav.addClass(hoverClass);
        }, 1000);
    });
    
    $(document).on('click','.navt-dismiss',function() {
        $(this).parents('.navt').children('.navt-button').click();
    });
    
   
    $(document).on('click','.btn-newsletter',function() {
        $('.cc-popup[data-section-type="newsletter-popup"]').css({"opacity": "1", "visibility": "visible"});
    });
    $(document).on('click','.cc-popup-close',function() {
        $('.cc-popup[data-section-type="newsletter-popup"]').css({"opacity": "0", "visibility": "hidden"});
    });
    
});
// end navtoggle